import { Component, Vue } from 'vue-property-decorator';
import { TaskResponse } from '@/classes/task/types';

export interface HttpErrorOutcome {
  type: 'success' | 'info' | 'warning' | 'error';
  message: string;
  isStaleState: boolean;
  shouldReloadPretension: boolean;
}

@Component
export default class PretensionHttpErrorMixin extends Vue {
  classifyHttpError(taskResponse: TaskResponse): HttpErrorOutcome {
    const description = typeof taskResponse.result[0] === 'string' ? taskResponse.result[0] : null;

    switch (taskResponse.code) {
      case 400:
        return {
          type: 'error',
          message: description || 'Невалидные данные',
          isStaleState: false,
          shouldReloadPretension: false,
        };
      case 403:
        return {
          type: 'error',
          message: 'Недостаточно прав для операции',
          isStaleState: true,
          shouldReloadPretension: true,
        };
      case 409:
        return {
          type: 'warning',
          message: 'Статус претензии изменился, страница будет обновлена',
          isStaleState: true,
          shouldReloadPretension: true,
        };
      case 410:
        return {
          type: 'info',
          message: 'Процесс уже завершён или отменён',
          isStaleState: true,
          shouldReloadPretension: true,
        };
      case 502:
        return {
          type: 'error',
          message: 'Сервис временно недоступен, попробуйте позже',
          isStaleState: false,
          shouldReloadPretension: false,
        };
      case 504:
        return {
          type: 'error',
          message: 'Сервис не отвечает, попробуйте позже',
          isStaleState: false,
          shouldReloadPretension: false,
        };
      default:
        return {
          type: 'error',
          message: `Возникла ошибка, попробуйте позже${description ? ` — ${description}` : ''}`,
          isStaleState: false,
          shouldReloadPretension: false,
        };
    }
  }
}
